import { FC, useCallback, useContext } from 'react'
import { IconButton, ModalContext, ModalHeader } from '@cargomart/ui'
import { MODAL_IDS, useModal } from 'components/ModalProvider'
import some from 'lodash/some'
import IconArrowLeft from 'remixicon/icons/Arrows/arrow-left-line.svg?react'
import IconMore from 'remixicon/icons/System/more-2-fill.svg?react'
import { OrderAccess, OrderItem } from 'schema'

import { formattedSerialId } from '../../helpers'
import OrderAction from '../OrderAction'

interface OrderYarcheDetailMobileHeaderProps {
  order: OrderItem
}

const OrderYarcheDetailMobileHeader: FC<OrderYarcheDetailMobileHeaderProps> = (props) => {
  const { order } = props
  const { openModal } = useModal()
  const { isStickyHeader, onClose } = useContext(ModalContext)
  const isShowAction = some(order?.access, (current) => Boolean(current))

  const handleCancel = useCallback(() => {
    openModal(MODAL_IDS.CancelOrder)
  }, [openModal])

  return (
    <ModalHeader isBgSurface isSticky className="flex items-center justify-between !rounded-none" tabIndex={0}>
      <div className="flex w-full gap-x-2 p-1">
        <IconButton onClick={onClose} size="lg">
          <IconArrowLeft containerSize="lg" size="nm" />
        </IconButton>
        <div className="self-center truncate text-title-lg">{isStickyHeader && formattedSerialId(order?.serialId)}</div>
        {isShowAction && (
          <OrderAction
            access={order?.access as OrderAccess}
            id={order.id}
            onCancel={handleCancel}
            trigger={
              <IconButton className="ml-auto" size="lg" title="Действия">
                <IconMore containerSize="lg" size="nm" />
              </IconButton>
            }
          />
        )}
      </div>
    </ModalHeader>
  )
}

export default OrderYarcheDetailMobileHeader
